<app-note-form [hasHeader]="false" [showMessage]="false" [showLabel]="false" marginCls=""></app-note-form>
